/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Especialty from './especialty';
import EspecialtyDetail from './especialty-detail';
import EspecialtyUpdate from './especialty-update';
import EspecialtyDeleteDialog from './especialty-delete-dialog';

const EspecialtyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Especialty />} />
    <Route path="new" element={<EspecialtyUpdate />} />
    <Route path=":id">
      <Route index element={<EspecialtyDetail />} />
      <Route path="edit" element={<EspecialtyUpdate />} />
      <Route path="delete" element={<EspecialtyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EspecialtyRoutes;
